import { render, staticRenderFns } from "./AddDistributor.vue?vue&type=template&id=86e5e6e8&scoped=true&"
import script from "./AddDistributor.vue?vue&type=script&lang=js&"
export * from "./AddDistributor.vue?vue&type=script&lang=js&"
import style0 from "./AddDistributor.vue?vue&type=style&index=0&id=86e5e6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e5e6e8",
  null
  
)

export default component.exports